module.exports = __webpack_public_path__ + "media/images/driving_school/lesson_cdr-e792d343326efb439d37c825376e7ad9.png";